import { render, staticRenderFns } from "./GameType.vue?vue&type=template&id=17565d60&scoped=true&"
import script from "./GameType.vue?vue&type=script&lang=js&"
export * from "./GameType.vue?vue&type=script&lang=js&"
import style0 from "./GameType.vue?vue&type=style&index=0&id=17565d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17565d60",
  null
  
)

export default component.exports